import React, { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import AuthShell, { authInput } from "@/pages/AuthShell";
import { Loader2 } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      setTimeout(() => nav("/login"), 1600);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
      setLoading(false);
    }
  };

  return (
    <AuthShell eyebrow="Password Reset" title="Set a new password"
      footer={<Link to="/login" style={{ color: "#2038E6" }}>Back to login</Link>}>
      {done ? (
        <p data-testid="reset-done" style={{ color: "var(--muted)" }}>Password updated. Redirecting to login...</p>
      ) : (
        <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <input data-testid="reset-password" type="password" placeholder="New password (min 8 chars)" value={password} onChange={(e) => setPassword(e.target.value)} style={authInput} />
          {error && <span style={{ color: "#b00020", fontSize: 14 }} data-testid="reset-error">{error}</span>}
          <button className="btn-cobalt" type="submit" disabled={loading || !token} data-testid="reset-submit" style={{ justifyContent: "center" }}>
            {loading ? <Loader2 size={18} className="animate-spin" /> : "Update password"}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
